"use client";

import Image from "next/image";
import React, { useMemo, useState } from "react";
// import { motion } from "framer-motion";
// import { useInView } from "react-intersection-observer";

export const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#eee" offset="20%" />
      <stop stop-color="#dadada" offset="50%" />
      <stop stop-color="#eee" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#eee" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

export const toBase64 = (str: string) => (typeof window === "undefined" ? Buffer.from(str).toString("base64") : window.btoa(str));

function arePropsEqual<P>(prevProps: Readonly<P>, nextProps: Readonly<P>): boolean {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}

function ProductImageComponent({ alt, src }: { src: string; alt: string }) {
  return (
    <>
 
      <Image
        src={src}
        alt={alt}
        // placeholder="blur"
        // blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI2UwZTBlMCIgLz4KICA8cmVjdCBpZD0iciciIHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSJ1cmwoI2cpIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9IngiIGZyb209Ii00MDAiIHRvPSI0MDAiIGR1cj0iMS41cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgPC9yZWN0PgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJnIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2UwZTBlMCIgb2Zmc2V0PSIwIiAvPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjZjBmMGYwIiBvZmZzZXQ9IjAuNSIgLz4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2UwZTBlMCIgb2Zmc2V0PSIxIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPgo="
        placeholder={`data:image/svg+xml;base64,${toBase64(shimmer(700, 475))}`}
        fill
        unoptimized
        loading="lazy"
        style={{ objectFit: "cover", borderRadius: "16px" }}
       
      />
    </>
  );
}

export default React.memo(ProductImageComponent, arePropsEqual);
